<template>
  <div v-if="site && site.canViewCompliance" class="compliance-list">
    <ul>
      <li v-for="(compliance, index) in dues" :key="index">
        <b-icon
          v-if="compliance.status === 'BLANK_DUE'"
          icon="exclamation-circle-fill"
          variant="
        secondary"
          class="compliance--missing"
        ></b-icon>
        <b-icon
          v-else-if="compliance.status === 'DUE'"
          icon="exclamation-circle-fill"
          variant="warning"
          class="compliance--due"
        ></b-icon>
        <b-icon
          v-else-if="compliance.status === 'OVER_DUE'"
          icon="exclamation-circle-fill"
          variant="danger"
          class="compliance--overdue"
        ></b-icon>
        {{ compliance.description }}
      </li>
    </ul>
  </div>
</template>
<script>
/**
 * ==================================================================================
 * Due compliance/Test list
 * ==================================================================================
 **/

import Site from '@/models/Site'

export default {
  props: {
    site: {
      type: [Site, Object]
    }
  },

  computed: {
    dues() {
      return this.site && this.site.compliance ? this.site.compliance : []
    }
  }
}
</script>
<style lang="scss" scoped>
@mixin warning-color($variant, $color) {
  .bi-exclamation-circle-fill.compliance--#{$variant} {
    color: $color !important;
  }
}

.compliance-list {
  ul {
    padding: 0;
    margin-bottom: 0;

    li {
      display: block;
      padding-bottom: 2.5px;

      @include warning-color('overdue', #f93a2c);
      @include warning-color('due', #f5a321);
      @include warning-color('missing', #9b9b9b);

      .b-icon {
        margin-right: 2px;
      }
    }

    li:last-child {
      padding-bottom: 0;
    }
  }
}
</style>
